import HubspotForms from '../../hubspot-forms'
import { CLICK_ID } from '../../../utils/constants/enum'
import './get-in-touch.scss'

const GetInTouch = () => {
    const handleSignUpButton = (form: HTMLFormElement) => {
        const submitButton = form?.querySelector('input[type="submit"]')
        if (submitButton) {
            submitButton.id = CLICK_ID.NEWSLETTER_SIGNUP
        }
    }
    return (
        <div className="get-in-touch">
            <p className="subtitle">Subscribe for updates</p>
            <p className="description">
                Stay up-to-date with Hydrafacial special offers and exciting
                updates.
            </p>
            <div className="footer-email">
                <HubspotForms
                    FormId={process.env.REACT_APP_HUB_SPOT_EMAIL_SUBSCRIBE}
                    type={'subscribe-form'}
                    className="subscribe-form subscriber-footer-form"
                    onFormReady={handleSignUpButton}
                />
            </div>
        </div>
    )
}

export default GetInTouch
